import React, { useMemo, useState } from "react";
import AuthProvider from "../../auth/AuthProvider";
import JamezzFormV2 from "../JamezzForm/JamezzFormV2";
import TranslationWrapper, { getTranslation } from "../../components/TranslationWrapper/TranslationWrapper";
import { connect } from "react-redux";
import CurrencyProvider from "../../components/Forms/CurrencyProvider";
import useVestigingRelation from "../../components/Forms/useVestigingRelation";
import VestigingProvider from "../../components/Forms/VestigingProvider";
import Algemeen from "./Tabs/Algemeen";

import { formatTitle } from "../../../utils/formatting";
import { Link } from "react-router";
import Counters from "./Tabs/Counters";
import { format, parseISO } from "date-fns";
import PercentageOffTotal from "./Tabs/PercentageOffTotal";
import AmountOffTotal from "./Tabs/AmountOffTotal";
import PercentageOffProduct from "./Tabs/PercentageOffProduct";
import AmountOffProduct from "./Tabs/AmountOffProduct";
import AddDiscountProduct from "./Tabs/AddDiscountProduct";
import CollectionSettings from "./Tabs/CollectionSettings";
import { useSwitchToSalesarea } from "../Vestigingen/UseSwitchToSalesarea";
import _ from "lodash";

function VoucherDefsForm(props) {
  const endPoint = useMemo(() => {
    return "core/voucherdefs";
  }, []);
  const [discountType, setDiscountType] = useState(null);

  const { currency, menukaartVestigingId, vestiging, extraFields, onGetModel } = useVestigingRelation({
    vestiging_id: props.vestiging_id,
    routerMatch: props.match,
    history: props.history,
    endPoint,
  });
  useSwitchToSalesarea(vestiging);

  const tabs = useMemo(() => {
    const tabs = [
      {
        right: "algemeen",
        tabButton: <TranslationWrapper tDefault={"Main settings"} tKey={"voucherDefs.form.tabs.algemeen"} />,
        tabContent: <Algemeen />,
      },
    ];

    if (discountType === "COLLECTION") {
      tabs.push({
        right: "collection",
        tabButton: <TranslationWrapper tDefault={"Collection settings"} tKey={"voucherDefs.form.tabs.collection"} />,
        tabContent: <CollectionSettings />,
      });
    } else if (discountType === "ADD_DISCOUNTED_PRODUCT") {
      tabs.push({
        right: "add_discounted_product",
        tabButton: (
          <TranslationWrapper
            tDefault={"Add Discounted Product - settings"}
            tKey={"voucherDefs.form.tabs.add_discounted_product"}
          />
        ),
        tabContent: <AddDiscountProduct />,
      });
    } else if (discountType === "PERCENTAGE_OFF_TOTAL") {
      tabs.push({
        right: "percentage_off_total",
        tabButton: (
          <TranslationWrapper
            tDefault={"Percentage Off Total - settings"}
            tKey={"voucherDefs.form.tabs.percentage_off_total"}
          />
        ),
        tabContent: <PercentageOffTotal />,
      });
    } else if (discountType === "AMOUNT_OFF_TOTAL") {
      tabs.push({
        right: "amount_off_total",
        tabButton: (
          <TranslationWrapper
            tDefault={"Amount Off Total - settings"}
            tKey={"voucherDefs.form.tabs.amount_off_total"}
          />
        ),

        tabContent: <AmountOffTotal />,
      });
    } else if (discountType === "PERCENTAGE_OFF_PRODUCT") {
      tabs.push({
        right: "percentage_off_product",
        tabButton: (
          <TranslationWrapper
            tDefault={"Percentage Off Product - settings"}
            tKey={"voucherDefs.form.tabs.percentage_off_product"}
          />
        ),
        tabContent: <PercentageOffProduct />,
      });
    } else if (discountType === "AMOUNT_OFF_PRODUCT") {
      tabs.push({
        right: "amount_off_product",
        tabButton: (
          <TranslationWrapper
            tDefault={"Amount Off Product - settings"}
            tKey={"voucherDefs.form.tabs.amount_off_product"}
          />
        ),
        tabContent: <AmountOffProduct />,
      });
    }
    tabs.push({
      right: "algemeen",
      tabButton: <TranslationWrapper tDefault={"Counters"} tKey={"voucherDefs.form.tabs.counters"} />,
      tabContent: <Counters />,
    });
    return tabs;
  }, [discountType]);

  return (
    <AuthProvider prefix={"voucherDefs"}>
      <CurrencyProvider currency={currency}>
        <VestigingProvider vestiging={vestiging}>
          <JamezzFormV2
            computedPageTitle={function (model) {
              return formatTitle(this.pageTitle, model.naam);
            }}
            customFieldSerialization={{
              onlyifProductsInBasket_JSON: (arr) => JSON.stringify(arr),
              freeProducts_JSON: (arr) => JSON.stringify(arr),
              menus: (menus) => JSON.stringify(menus),
              supergroups: (supergroups) => JSON.stringify(supergroups),
              discounted_products: (discounted_products) =>
                JSON.stringify(
                  _.chain(discounted_products)
                    .mapValues((product) => _.pick(product, ["id", "maxCount", "name", "optionGroups"]))
                    .values()
                    .value()
                ),
            }}
            endPoint={endPoint}
            excludedKeysInOutput={{}}
            extraFields={extraFields}
            extraFormProps={{
              vestiging,
              vestigingId: vestiging?.id ?? props.vestiging_id,
              menukaartVestigingId,
            }}
            mode={"onSubmit"}
            objectsExcludedAsRelation={{ menus: true }}
            onGetModel={(model) => {
              setDiscountType(model.discountType);
              onGetModel(model);
            }}
            pageTitle={getTranslation("voucherDefs.form.pageTitle", "Voucher definitions")}
            pageTitleSubject={
              <small>
                <Link to={`/manager/vestigingen/${vestiging?.id}/edit`}>{vestiging?.naam}</Link> - {vestiging?.id}
              </small>
            }
            parseInput={{
              supergroups: (supergroups) => {
                return JSON.stringify(supergroups?.supergroups?.map((supergroup) => supergroup.id) ?? []);
              },
              custom_data: (input) => (!input || Array.isArray(input) ? {} : input),
              dateUntil: (input) => {
                return input != null ? format(parseISO(input), "yyyy-MM-dd'T'HH:mm:ss") : null;
              },
              dateFrom: (input) => {
                return input != null ? format(parseISO(input), "yyyy-MM-dd'T'HH:mm:ss") : null;
              },
              discounted_products: (input) => {
                console.log(input);
                return input !== null
                  ? input.map((product) => ({
                      id: product.id,
                      name: product.name,
                      maxCount: product.maxCount,
                      optionGroups: product.optionGroups,
                    }))
                  : null;
              },
            }}
            parseOutput={{ custom_data: (arr) => JSON.stringify(arr) }}
            revalidateMode={"onChange"}
            tabs={tabs}
          />
        </VestigingProvider>
      </CurrencyProvider>
    </AuthProvider>
  );
}

const mapStateToProps = (state) => {
  return {
    vestiging_id: state.filtersV2.vestiging_id?.value,
  };
};

export default connect(mapStateToProps)(VoucherDefsForm);
